import { accountNames, getBusinessCapabilities } from './accountStubData';

const padAccountEnd = (num) => num.toString().padStart(4, '0');

const getAmountValue = (accNumber = '2', baseAmount = 123) => {
	const multiplier = parseInt(accNumber.charAt(accNumber.length - 1), '10');
	return multiplier * baseAmount;
};

const buildAccount = ({
	number,
	sortCode = '823000',
	name = 'Business Current',
	description = 'STANDARD BUSINESS',
	id = uuid.v1(),
	nickName = name,
}) => {
	const accNumber = padAccountEnd(number);

	return {
		type: 'current',
		number: `${sortCode}-${accNumber}`,
		product: {
			code: '220',
			name,
			description,
		},
		actions_available: getBusinessCapabilities(),
		source_system: 'IMP',
		bank_id: 'CB',
		metadata: {
			display_order: 0,
			account_name: `${name} ${accNumber}`,
			display_name: `${nickName}`,
		},
		balances: [
			{
				type: 'current',
				amount: {
					value: getAmountValue(accNumber, 850),
					currency: 'GBP',
				},
			},
			{
				type: 'available',
				amount: {
					value: getAmountValue(accNumber, 120),
					currency: 'GBP',
				},
			},
			{
				type: 'cleared',
				amount: {
					value: getAmountValue(accNumber, 210),
					currency: 'GBP',
				},
			},
		],
		payment_limits: {},
		id,
		limits: [
			{
				type: 'overdraft',
				amount: {
					currency: 'GBP',
					value: 0,
				},
				effective_period: {
					from: '',
					to: '',
				},
			},
		],
	};
};

const accounts = accountNames.map(buildAccount);
export default accounts;
